<template>
  <v-container class="pa-0">
    <v-row justify="center">
      <v-col cols="12" class="px-3">
        <v-row v-if="settings && settings.title">
          <v-col cols="12">
            <h1 class=".display-1">{{ settings.title }}</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" v-if="settings && settings.show_video">
            <video
              id="video-player"
              ref="videoPlayer"
              class="video-js"
              >
            </video>
          </v-col>
          <v-col cols="12" md="6" v-if="settings && settings.description" class="description-container">
            <p class="text-justify px-5 mb-10">{{ settings.description }}</p>
            <v-btn
              absolute
              dark
              bottom
              right
              color="primary"
              v-if="settings && settings.show_button"
              @click="goToButtonAction"
            >
              {{ settings.button_text }}
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-if="settings && settings.show_news && news.length > 0">
      <v-col cols="12" class="text-center">
        <h2 class=".display-1">{{ $t('dashboard.titles.news') }}</h2>
      </v-col>
      <!-- <v-col cols="12">
        <v-slide-group multiple show-arrows>
          <v-slide-item
            v-for="n in 25"
            :key="n"
          >
            <v-card class="video-card" height="100%">
              <v-img
                :aspect-ratio="16/9"
                src="src"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.7)"
                height="200px"
              >
                <v-card-title class="video-card-title">
                  TEST
                </v-card-title>
              </v-img>
              <v-card-text class="pb-0 mb-6">DESC</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>favorite_outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('library.tooltips.remove-favorite') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>play_circle_outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('library.tooltips.play') }}</span>
                </v-tooltip>
              </v-card-actions>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-col> -->
      <v-col cols="12">
        <v-slide-group
          v-model="slide_news"
          class="pa-4 slider-container"
          prev-icon="chevron_left"
          next-icon="chevron_right"
          width="100%"
        >
          <v-slide-item
            v-for="video in news"
            :key="video.id"
          >
            <v-col cols="12" md="4" xl="3">
              <video-card :video="video"></video-card>
            </v-col>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-row v-if="settings && settings.show_components">
      <v-col cols="12" class="text-center">
        <h2 class=".display-1">{{ $t('dashboard.titles.components') }}</h2>
      </v-col>
      <v-col cols="12">
        <v-slide-group
          v-model="slide_components"
          class="pa-4"
          prev-icon="chevron_left"
          next-icon="chevron_right"
        >
          <v-slide-item
            v-for="component in components"
            :key="component.id"
          >
            <v-col cols="12" md="3" xl="2">
              <v-card height="100%">
                <v-img
                  @click="navigateTo('component', component)"
                  :aspect-ratio="4/3"
                  :src="component.image_url"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.7)"
                >
                  <v-card-title @click="navigateTo('component', component)">
                    <span class="text-truncate">{{ component.name }}</span>
                  </v-card-title>
                </v-img>
                <v-card-text>{{ component.description }}</v-card-text>
              </v-card>
            </v-col>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-overlay :value="!loaded" opacity="1" color="white" light absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<style lang="scss">
.description-container {
  position: relative;
}

.v-card__title,
.v-image {
  cursor: pointer;
}

</style>

<script>

import videojs from 'video.js'
import 'video.js/dist/video-js.css'

import { getUrlImage, getUrlVideo } from '@/store/storage'
import { getDocById } from '@/store/module/video'
import { getHomeSettings } from '@/store/module/settings'
import { getDocumentsFromCollection as getComponents } from '@/store/module/component'
import { getNewsVideos } from '@/store/module/video'
import VideoCardComponent from '@/components/VideoCard'

export default {
  components: {
    'video-card': VideoCardComponent
  },
  data: () => ({
    loaded: false,
    loading_page: {
      video: false,
      components: false,
      videos: false
    },
    player: null,
    settings: null,
    news: [],
    components: [],
    slide_news: null,
    slide_components: null
  }),

  mounted() {
    getHomeSettings().then(settings => {
      this.settings = settings
      if (this.settings.show_video) {
        this.initVideo()
      }
      if (this.settings.show_components) {
        this.initComponents()
      }
      if (this.settings.show_news) {
        this.initNews()
      }
    })
  },

  methods: {
    isLoaded() {
      return (
          (!this.settings.show_video || this.loading_page.video) &&
          (!this.settings.show_components || this.loading_page.components) &&
          (!this.settings.show_news || this.loading_page.videos)
      )
    },
    navigateTo(type, resource) {
      this.$router.push({ name: "Library", params: { type: type, resource: resource } })
    },
    initNews() {
      getNewsVideos(this.settings.news_days).then(async videos => {
        for (let video of videos) {
          video.url = 'video/'+video.id
          await getUrlImage(video.image, 'video').then(url => {
            video.image_url = url
          })
        }
        this.news = videos

        //check if loaded
        this.loading_page.videos = true
        this.loaded = this.isLoaded()
      })
    },
    initComponents() {
      getComponents('components').then(async components => {
        for (let component of components) {
          component.url = 'component/'+component.id
          await getUrlImage(component.image, 'component').then(url => {
            component.image_url = url
          })
        }
        this.components = components

        //check if loaded
        this.loading_page.components = true
        this.loaded = this.isLoaded()
      })
    },
    async initVideo() {
      let poster = null
      let source = {
        src: null
      }
      let video = video
      let videoRef = getDocById('videos', this.settings.video)
      await videoRef.get().then(snapshot => {
        video = snapshot.data()
      })
      await getUrlImage(video.image, 'video').then(url => {
        poster = url
      })
      await getUrlVideo(video.video)
      .then(url => {
        source.src = url
      })

      let params = {
        controls: true,
        autoplay: false,
        preload: 'none',
        width: '100%',
        aspectRatio: '16:9',
        poster: poster,
        src: source
      }

      this.player = videojs(this.$refs.videoPlayer, params)
      this.player.src(source)

      //check if loaded
      this.loading_page.video = true
      this.loaded = this.isLoaded()
    },
    goToButtonAction() {
      console.log('Go To', this.settings.button_type, this.settings.button_url);
    }
  }
}

</script>
